import { useOverlayRef } from '@aigc/overlay-hook';
import {
  Drawer as AntdDrawer,
  type DrawerProps as AntdDrawerProps,
} from 'antd';
import { useEffect, useState } from 'react';

export type AiDrawerProps = Omit<AntdDrawerProps, 'open'>;

export const AiDrawer = (props: AiDrawerProps) => {
  const overlayRef = useOverlayRef();
  const [open, setOpen] = useState(true);
  const [resolve, setResolve] = useState(() => () => {
    /* empty */
  });

  useEffect(() => {
    const dispose = overlayRef?.onBeforeClose(() => {
      return new Promise<void>((next) => {
        setOpen(false);
        setResolve(() => next);
      });
    });

    return () => {
      dispose?.();
    };
  }, [overlayRef]);

  return (
    <AntdDrawer
      {...props}
      open={open}
      afterOpenChange={(next_open) => {
        props.afterOpenChange?.(next_open);

        if (!next_open) {
          resolve();
        }
      }}
      onClose={props.onClose}
    >
      {props.children}
    </AntdDrawer>
  );
};
